import React, { useEffect } from 'react'

const usingTheme = (WrappedComponent, theme) => {
    const HOC = (props) => {
        useEffect(() => {
            if (theme) {
                document.documentElement.setAttribute("data-theme", theme);
            }
        }, []);
        return <WrappedComponent {...props} />
    }
    return HOC;
}
export default usingTheme;
